const main = () => {
    // 物件一覧 + お気に入り / 最近みた物件（ソート / まとめて資料請求）
    const page = document.querySelector('#page-estate-index, #page-favorite-index, #page-history-index');
    if (page == null) return;

    const navigateWithQuery = (name, value) => {
        const url = new URL(window.location.href);
        url.searchParams.set(name, value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
    };

    document.querySelectorAll('select[name="sort"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            navigateWithQuery('sort', e.currentTarget.value);
        });
    });

    document.querySelectorAll('select[name="per_page"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            navigateWithQuery('per_page', e.currentTarget.value);
        });
    });

    document.querySelectorAll('[data-sort-value]').forEach((button) => {
        button.addEventListener('click', () => {
            navigateWithQuery('sort', button.dataset.sortValue);
        });
    });

    // 種別タブ（検索できる4種別。件数0の種別はサーバ側で間引かれるのでタブ数は県ごとに変わる）
    // 種別はURLのパス（/{県}/list/{種別}/...）に載るため、遷移先URLはサーバ側が
    // 各タブの data-list-type-url に描画済み。
    // スラグ⇔コードの対応表はサーバにしかないので、JSでURLを組み立てさせない
    // （組み立てさせるとスラグ解決の実装が二重になり canonical・sitemap と食い違う）。
    //
    // 【2026-08-21 チェックボックス → ラジオ。設計メモ D25】
    // 種別は常に1つだけ選ばれている。以前あった
    //   - 0件選択（全部外した状態）→ /list/all/ へ
    //   - 複数選択 → パスで表現できないので type[] をクエリで足す（noindex,follow 行き）
    // の2分岐は、どちらも構造的に起こり得なくなったので撤去した。
    //
    // 【同日 「すべて」タブの撤去に伴い allUrl フォールバックも撤去】
    // data-list-type-url-all（種別指定なしの遷移先）を3通りの保険として読んでいたが、
    // いずれも到達不能だった:
    //   - 「1つも checked が無いとき」… 共通部品が必ず1つ checked にする
    //   - 「タブに data-list-type-url が無いとき」… この画面の全タブがURLを持つ
    //   - 「サーバがURLを配らないページ（お気に入り・閲覧履歴）」… あちらは
    //     .pg-list-controls__types 自体を描画しないので下の forEach が0件で空回りする
    // 「効いているつもりのコード」を残さないため、クエリで切り替える経路ごと消した。
    // ラジオの change は**新しく checked になった input 自身**で発火するので、
    // 全体を走査して checked を探し直す必要も無い
    document.querySelectorAll('.pg-list-controls__types input[name="type[]"]').forEach((input) => {
        input.addEventListener('change', () => {
            // URLが無いのはサーバ側の描画漏れ。黙って別の場所へ飛ばすより何もしない方が調べやすい
            const url = input.closest('[data-list-type-url]')?.dataset.listTypeUrl;
            if (url) window.location.href = url;
        });
    });

    const bulkInquiry = document.querySelector('#bulk-inquiry');
    const checkboxes = [...document.querySelectorAll('input[name="ids[]"][form="bulk-inquiry"]')];

    if (bulkInquiry == null || checkboxes.length === 0) return;

    const count = bulkInquiry.querySelector('[data-bulk-inquiry-count]');
    const submitButtons = [...document.querySelectorAll(
        'button[form="bulk-inquiry"], #bulk-inquiry button[type="submit"]'
    )];
    let hideTimer = null;

    const updateBulkInquiry = () => {
        const selectedCheckboxes = checkboxes.filter((checkbox) => checkbox.checked);
        const hasSelection = selectedCheckboxes.length > 0;

        submitButtons.forEach((button) => {
            button.disabled = !hasSelection;
        });

        if (hasSelection) {
            window.clearTimeout(hideTimer);
            count.textContent = selectedCheckboxes.length;
            bulkInquiry.hidden = false;
            bulkInquiry.classList.remove('is-leaving');
            page.classList.add('is-bulk-inquiry-visible');
        } else if (!bulkInquiry.hidden) {
            bulkInquiry.classList.add('is-leaving');
            hideTimer = window.setTimeout(() => {
                if (checkboxes.some((checkbox) => checkbox.checked)) return;

                bulkInquiry.hidden = true;
                bulkInquiry.classList.remove('is-leaving');
                page.classList.remove('is-bulk-inquiry-visible');
            }, 400);
        }

        document.querySelectorAll('.c-cards-estate[data-selectable]').forEach((card) => {
            const checkbox = card.querySelector('input[name="ids[]"]');
            card.toggleAttribute('data-selected', checkbox?.checked === true);
        });
    };

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', updateBulkInquiry);
    });

    bulkInquiry.addEventListener('submit', (event) => {
        if (!checkboxes.some((checkbox) => checkbox.checked)) {
            event.preventDefault();
        }
    });

    updateBulkInquiry();
}

export default main;
